module.exports = __webpack_public_path__ + "img/bg-symptom2.59b2b3d1.png";